import React from 'react';
import styled from 'styled-components';

import * as ICONS from './svg';

const Wrapper = styled.div`
  vertical-align: middle;
  & > img {
    /* https://stackoverflow.com/questions/5804256/image-inside-div-has-extra-space-below-the-image */
    display: block;
  }
`;

export const devAllIcons = ICONS;

export default function IconSvgComponent({
  icon,
  alt,
  className,
  size,
  inline = false,
}: {
  icon: keyof typeof ICONS;
  alt?: string;
  className?: string;
  size?: string;
  inline?: boolean;
}) {
  return (
    <Wrapper
      as={inline ? 'span' : 'div'}
      className={className}
      style={inline ? { display: 'inline-block' } : undefined}
    >
      <img
        // Safety handled by TypeScript, can be ignored
        // eslint-disable-next-line import/namespace
        src={ICONS[icon]}
        alt={alt ?? ''}
        style={size ? { width: size, height: size } : undefined}
      />
    </Wrapper>
  );
}
